// extracted by css-extract-rspack-plugin
export default {"root":"src-wab-client-plasmic-plasmic_kit_style_controls-PlasmicSectionCollapseButton-module__root-MLeQr6","svg":"src-wab-client-plasmic-plasmic_kit_style_controls-PlasmicSectionCollapseButton-module__svg-BwFRcH","svgisExpanded":"src-wab-client-plasmic-plasmic_kit_style_controls-PlasmicSectionCollapseButton-module__svgisExpanded-fHsD0k"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-wab-client-plasmic-plasmic_kit_style_controls-PlasmicSectionCollapseButton-module__root-MLeQr6\",\"svg\":\"src-wab-client-plasmic-plasmic_kit_style_controls-PlasmicSectionCollapseButton-module__svg-BwFRcH\",\"svgisExpanded\":\"src-wab-client-plasmic-plasmic_kit_style_controls-PlasmicSectionCollapseButton-module__svgisExpanded-fHsD0k\"}";
        // 1793541999159
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  